import { Conversation } from './types';

const STORAGE_KEY = 'paceChat-conversations';
const MAX_AGE_DAYS = 30;

export function loadAllConversations(): Conversation[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch {
    return [];
  }
}

function saveAll(conversations: Conversation[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
  } catch (e) {
    console.warn('Failed to save conversations to localStorage:', e);
  }
}

export function saveConversation(conv: Conversation): void {
  const all = loadAllConversations();
  const idx = all.findIndex(c => c.id === conv.id);
  if (idx >= 0) {
    all[idx] = conv;
  } else {
    all.push(conv);
  }
  saveAll(all);
}

export function deleteConversation(id: string): void {
  const all = loadAllConversations().filter(c => c.id !== id);
  saveAll(all);
}

export function getConversationsForAgent(agentId: string): Conversation[] {
  return loadAllConversations()
    .filter(c => c.agentId === agentId)
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
}

export function purgeOldConversations(): number {
  const all = loadAllConversations();
  const cutoff = Date.now() - MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
  const filtered = all.filter(c => new Date(c.updatedAt).getTime() > cutoff);
  const purged = all.length - filtered.length;
  if (purged > 0) {
    saveAll(filtered);
    console.log(`[conversationStorage] Purged ${purged} old conversations`);
  }
  return purged;
}

export function generateConversationTitle(firstMessage: string): string {
  const clean = firstMessage.trim().replace(/\n+/g, ' ');
  if (clean.length <= 50) return clean;
  const truncated = clean.substring(0, 50);
  const lastSpace = truncated.lastIndexOf(' ');
  return (lastSpace > 20 ? truncated.substring(0, lastSpace) : truncated) + '...';
}
